import { render, staticRenderFns } from "./ContaReceber.vue?vue&type=template&id=49552c92&"
import script from "./ContaReceber.vue?vue&type=script&lang=js&"
export * from "./ContaReceber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports